import React from 'react';
import { connect } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { YouTube } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { IAppState } from '../../../../state/reducers';
import { selectUserPublishSettings } from '../../../../state/publishEndpoints';
import { IPublishSettings, SettingType } from '../../../../api/vault/publishEndpoints';
import SocialIcon from '../../SocialIcon';
import {
  IDispatchProps, IProps, IState, IStateProps,
} from './interfaces';
import { ISearchResultsLocaleLookupKeys, LocaleKeyTree } from '../../../../localization';
import { UiSection } from '../../../../enums';
import { initializeSocialPublishing, openSocialPublishDialog } from '../../../../state/publishAssets';

class SocialPublishOptions extends React.Component<IProps, IState> {
  private static readonly socialButtonId = `${UiSection.SearchResults}.Social`;
  private readonly localeLookupKeys: Readonly<ISearchResultsLocaleLookupKeys> = LocaleKeyTree.searchResults;

  state: Readonly<IState> = {
    anchorEl: null,
  };

  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleProfileSelect = (profile: IPublishSettings<any>) => {
    const {
      openSocialPublishDialogConnect,
      initializeSocialPublishingConnect,
      onProfileSelect,
    } = this.props;

    initializeSocialPublishingConnect(profile);
    openSocialPublishDialogConnect();
    if (_.isFunction(onProfileSelect)) {
      onProfileSelect(profile.type);
    }
    this.handleClose();
  };

  renderProfiles(type: SettingType) {
    const {
      t,
      publishSettings,
    } = this.props;

    return publishSettings.filter((s) => s.type === type).map((s) => (
      <MenuItem onClick={() => this.handleProfileSelect(s)} key={s._id}>
        <SocialIcon type={type} />
        {s.settings.profileName}
      </MenuItem>
    ));
  }

  render() {
    const {
      t,
      publishSettings,
      disabled,
      socialButton: SocialButton,
      socialType,
    } = this.props;

    const {
      anchorEl,
    } = this.state;

    if (publishSettings === null) {
      return null;
    }

    const isOpen = Boolean(anchorEl);

    let SocialView: any = `${t(this.localeLookupKeys.socialButtonText)}`;
    const menuItems: any[] = [];
    if (socialType) {
      if (socialType === SettingType.Twitter) {
        SocialView = <SocialIcon type={SettingType.Twitter_White} />;
        menuItems.push(this.renderProfiles(SettingType.Twitter));
      } else if (socialType === SettingType.YouTube) {
        SocialView = <YouTube />;
        menuItems.push(this.renderProfiles(SettingType.YouTube));
      }
    } else { // default to show all
      menuItems.push(this.renderProfiles(SettingType.Twitter));
      menuItems.push(this.renderProfiles(SettingType.YouTube));
    }

    return (
      <div>
        <SocialButton
          id={SocialPublishOptions.socialButtonId}
          onClick={this.handleClick}
          disabled={disabled}
          data-auto={socialType}
        >
          {SocialView}
        </SocialButton>
        <Menu
          id="simple-menu"
          data-auto="SocialMenuList"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          open={isOpen}
          onClose={this.handleClose}
        >
          {menuItems}
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  publishSettings: selectUserPublishSettings(state),
});

const mapDispatchToProps: IDispatchProps = {
  initializeSocialPublishingConnect: initializeSocialPublishing,
  openSocialPublishDialogConnect: openSocialPublishDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SocialPublishOptions));
